import { Timestamp } from 'firebase-admin/firestore';

// FireStore Document for Descript Drive
export interface DescriptDrive {
  driveID?: string; // Descript Drive ID
  lastSynced: Timestamp; // Last time the drive was checked against Descript
  drivePlan?: DescriptDriveEntitlement; // Descript Drive Plan
  created?: Timestamp; // Date Drive was created
  claimed?: boolean; // Drive Claimed Status
  orgID?: string; // Organization ID that was linked to this Drive
  linkStatus?: 'NOT_STARTED' | 'STARTED' | 'COMPLETE';
  entitlements?: DescriptDriveEntitlement; // first setup does not yet include entitlements
  driveName?: string; // Descript Drive Name
}
export interface DescriptBillingQueryResponse {
  driveID?: string; // Descript Drive ID
  drivePlan?: DescriptDriveEntitlement; // Descript Drive Plan
  drive_name?: string; // Descript Drive Name
  product_group?: string; // Descript Product Group
  plan_refresh_date?: number; // Date of next billing cycle
  monthly_transcription_hours?: number; // Total Hours
  error: { statusCode?: number; error?: string; message?: string }; // Error Message from err.request.data
}

export interface DescriptLinkResponse {
  driveID: string; // Descript Drive ID
  isDriveOwner: boolean; // Is the user the owner of the Descript Drive
  claimed: boolean; // Drive Claimed Status
  preApprovedOrgID?: string; // Organization ID to auto link with
  compositionName?: string; // Descript Composition Name
}

export interface DescriptDriveEntitlement {
  type?: DescriptPlanNames; // Plan Type
  billingCycleDate?: number; // Date of next billing cycle
  totalMonthlyHours?: number; // Total Hours
  planID?: string; // Descript Plan ID
}

export enum DescriptPlanNames {
  // V3
  FREE = 'descript_free', // Staging: price_1NLv3eKP34R6C976bnbdkREW Prod: price_1NXo6cKP34R6C976E6BWDwWl
  ENTERPRISE = 'descript_enterprise', // Staging: price_1NLv5uKP34R6C976WeTqdDwE Prod: price_1NXo7UKP34R6C976OHGmlr7L
  HOBBYIST_V3 = 'descript_hobbyist_v3', // Staging: price_1S46Q4KP34R6C976LClXLvT0 Prod: price_1S5AqVKP34R6C976xA0RwEqg
  EDUCATION_ORGS_V3 = 'descript_education_orgs_v3', // Staging: price_1S46RQKP34R6C9765MkBrTS3 Prod: price_1S5ArlKP34R6C9762R7P2Sp7
  CREATOR_V3 = 'descript_creator_v3', // Staging: price_1S46QeKP34R6C976FMwDNzbX Prod: price_1S5ArgKP34R6C976haLZEQge
  BUSINESS_V3 = 'descript_business_v3', // Staging: price_1S46R2KP34R6C976Kq6oGncu Prod: price_1S5ArjKP34R6C976wJlZakND
  // V2
  EDUCATION_ORGS_V2 = 'descript_education_orgs_v2', // Staging: price_1PXlv3KP34R6C976Hnxh1N2i Prod: price_1PWOUYKP34R6C9762YP7tc8Z
  CREATOR_V2 = 'descript_creator_v2', // Staging: price_1PXlqvKP34R6C976Zsf4ZKol Prod: price_1PWOSIKP34R6C976Vg92CoG4
  BUSINESS = 'descript_business', // Staging: price_1PIuu9KP34R6C976EXdbO2Lk Prod: price_1PLqPwKP34R6C9762zvQpQKw
  HOBBYIST = 'descript_hobbyist', // Staging: price_1PXlZSKP34R6C976uViU3dvw Prod: price_1PWORqKP34R6C976kppWNrJE
  // V1
  CREATOR = 'descript_creator', // Staging: price_1NLv5WKP34R6C976uELXV1sX Prod: price_1NXo72KP34R6C976a6i8x4MC (hobbyist legacy)
  PRO = 'descript_pro', // Staging: price_1NLud7KP34R6C9767TE3pubv Prod: price_1NXo7FKP34R6C9761XnVlkaA (creator legacy)
  EDU = 'descript_education_orgs', // Staging: price_1Ndb3cKP34R6C9762zBfX9FC Prod: price_1NehExKP34R6C976ElI5oA8E
}

export interface DescriptFile {
  name: string;
  uri: string;
  start_offset: StartOffsetWithSeconds;
}

export interface StartOffsetWithSeconds {
  seconds: number;
}

export interface DescriptImport {
  url?: string;
}
